import React from 'react'
import './index.scss'
import classNames from 'classnames'
import { Icon } from '@winnin/winnin_ui.components.icon'

export default function FakeSelect({ label, value, dropArrow, pointerCursor }) {
  const fakeSelectClass = classNames('FakeSelect', { PointerCursor: pointerCursor })
  return (
    <div className={fakeSelectClass}>
      <h5>
        <span className="light">{label} </span>
        <div className="FakeSelect-value">{value}</div>
        {dropArrow && <Icon icon="arrowDown" height={20} width={20} fill="var(--gray_dark2)" className="select-icon" />}
      </h5>
    </div>
  )
}
